// ./src/azure-storage-blob.ts

// <snippet_package>
// THIS IS SAMPLE CODE ONLY - NOT MEANT FOR PRODUCTION USE
import { BlobServiceClient, ContainerClient, BlockBlobParallelUploadOptions } from "@azure/storage-blob";

let containerName: string = ""; // `obdp-dropzone`;
let sasToken: string | null = null; // `sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2024-02-25T23:26:12Z&st=2022-02-25T15:26:12Z&spr=https&sig=7Ka0JSzDwbR84e0oiLtPc7TtpdqlM4hjl3tfBjIVpwI%3D`;
let storageAccountName: string | null = null; // `vfstsyroyhill`;

export interface ProgressUpload {
    (value: number): void;
}

// </snippet_package>

// <snippet_isStorageConfigured>
// Feature flag - disable storage feature to app if not configured
export const isStorageConfigured = () => {
    return !storageAccountName || !sasToken ? false : true;
};

export const setStorageCfg = (container_name: string, sas_token: string, storage_account_name: string) => {
    containerName = container_name;
    sasToken = sas_token;
    storageAccountName = storage_account_name;
};
// </snippet_isStorageConfigured>

/*
// <snippet_getBlobsInContainer>
// return list of blobs in container to display
const getBlobsInContainer = async (containerClient: ContainerClient) => {
    const returnedBlobUrls: string[] = [];

    // get list of blobs in container
    // eslint-disable-next-line
    for await (const blob of containerClient.listBlobsFlat()) {
        // if image is public, just construct URL
        returnedBlobUrls.push(`https://${storageAccountName}.blob.core.windows.net/${containerName}/${blob.name}`);
    }

    return returnedBlobUrls;
};
// </snippet_getBlobsInContainer>
*/

// <snippet_uploadFileToBlob>
const uploadFileToBlob = async (file: File | null, folder: string, callback: ProgressUpload, abort: AbortSignal) => {
    if (!file) return [];

    // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
    const blobService = new BlobServiceClient(`https://${storageAccountName}.blob.core.windows.net/?${sasToken}`);

    // get Container - full public read access
    const containerClient: ContainerClient = blobService.getContainerClient(containerName);
    
    // upload file
    const blobClient = containerClient.getBlockBlobClient(folder + file.name);

    // set mimetype as determined from browser with file upload control
    const options: BlockBlobParallelUploadOptions = {
        blobHTTPHeaders: { blobContentType: file.type },
        onProgress: (ev: any) => {
            // console.log(ev);
            callback(ev.loadedBytes);
        },
        abortSignal: abort,
    };

    // upload file
    await blobClient.uploadData(file, options);
};
// </snippet_uploadFileToBlob>

export default uploadFileToBlob;
